import axiosInstance from "./axiosInstance";

let api = axiosInstance()

export const HireTopLevelTalent = async(data, abortToken)=>{
  const config = {
      ...abortToken,
      timeout: 30000, // Set the timeout for this specific request
    };
  return  await api.post(`/HireTopLevelTalent`, data, config)
}